import { useState } from "react";
import { Flex, Space, Button, Table } from "@mantine/core";
import styled from "styled-components";
import { IAdminLog } from "../../../constants";
import moment from "moment";
import { convertTimestamp } from "../../../modules";

function AdminHistory({ logs = [] }: { logs?: IAdminLog[] }) {
  const [currentPage, setCurrentPage] = useState(1);
  const logsPerPage = 10; // Number of logs to display per page

  // Sort logs by createdAt timestamp in descending order
  const sortedLogs = [...logs].sort((a, b) => {
    const timeA = moment(convertTimestamp(a.createdAt as any));
    const timeB = moment(convertTimestamp(b.createdAt as any));
    return timeB.diff(timeA);
  });

  // Calculate the indices for pagination
  const indexOfLastLog = currentPage * logsPerPage;
  const indexOfFirstLog = indexOfLastLog - logsPerPage;
  const currentLogs = sortedLogs.slice(indexOfFirstLog, indexOfLastLog);

  // Handle page change
  const paginate = (pageNumber: number) => setCurrentPage(pageNumber);

  return (
    <Flex mih={300} direction={"column"}>
      <Title>History</Title>
      <Space h={"xl"} />
      <TableContainer>
        <Table striped highlightOnHover withTableBorder withColumnBorders>
          <Table.Thead>
            <Table.Tr>
              <Table.Th>Action</Table.Th>
              <Table.Th>Description</Table.Th>
              <Table.Th>Triggered By</Table.Th>
              <Table.Th>Date & Time</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {currentLogs.map((log, index) => {
              const sender =
                log?.sentBy?.name ||
                log?.sentBy?.email ||
                log?.createdBy ||
                "N/A";
              const senderSource = log?.sentBy?.source
                ? ` (${log.sentBy.source})`
                : "";
              const senderText = `${sender}${senderSource}`;
              return (
                <Table.Tr key={`${log.title}-${index}`}>
                  <Table.Td>{log.title}</Table.Td>
                  <Table.Td>{log.description}</Table.Td>
                  <Table.Td>{senderText}</Table.Td>
                  <Table.Td>
                    {moment(convertTimestamp(log.createdAt as any)).format(
                      "MMM DD, YYYY hh:mm:ss A"
                    )}
                  </Table.Td>
                </Table.Tr>
              );
            })}
          </Table.Tbody>
        </Table>
      </TableContainer>
      <Space h={"xl"} />
      {sortedLogs.length > logsPerPage && (
        <Flex justify={"center"} gap={10}>
          {Array.from({
            length: Math.ceil(sortedLogs.length / logsPerPage),
          }).map((_, index) => (
            <Button
              key={index + 1}
              onClick={() => paginate(index + 1)}
              variant={index + 1 === currentPage ? "filled" : "outline"}>
              {index + 1}
            </Button>
          ))}
        </Flex>
      )}
    </Flex>
  );
}

export default AdminHistory;

const Title = styled.div`
  font-family: Inter;
  font-size: 24px;
  font-weight: 800;
  line-height: 29px;
  letter-spacing: 0em;
  text-align: left;
`;

const TableContainer = styled.div`
  overflow-y: auto;
  max-height: 500px;
`;
